<template>
  <BaseDialog
    type="basic"
    :is-open="isOpen"
    :title="$t('organization.loginLessMember.title')"
    class="md:w-full"
    @click="emits('close')"
    @close="cancel"
  >
    <div class="flex flex-col pb-2">
      <LoginLessMemberNameField
        v-model="members"
        required
        :label="$t('organization.loginLessMember.names')"
        :supporting-text="$t('organization.loginLessMember.namesSupportingText')"
        :error="showError ? 'organization.loginLessMember.namesError' : ''"
        class="bg-surface-container-high mb-2"
      />
      <OrganizationTeamSelect v-model="teamId" class="mt-2" />
    </div>
    <template #dismiss>
      <BaseTextButton color="text" @click="cancel">{{ $t('common.cancel') }}</BaseTextButton>
    </template>
    <template #confirm>
      <BaseTextButton color="filled" @click="submit">{{
        $t('organization.loginLessMember.add')
      }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>
<script setup lang="ts">
  import { ref, watch } from 'vue'
  import BaseDialog from '../../../core/components/base/dialog/BaseDialog.vue'
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import LoginLessMemberNameField from './LoginLessMemberNameField.vue'
  import OrganizationTeamSelect from './OrganizationTeamSelect.vue'
  import type {
    AddLoginLessMembersBody,
    LoginLessMemberName,
  } from '../composables/useOrganizationSettings'

  interface Props {
    isOpen: boolean
  }
  const props = defineProps<Props>()

  const emits = defineEmits<{
    (e: 'close'): void
    (e: 'membersAdded', body: AddLoginLessMembersBody): void
  }>()

  const members = ref<LoginLessMemberName[]>([])
  const teamId = ref<string>()
  const showError = ref(false)

  watch(members, () => {
    if (members.value.length > 0) {
      showError.value = false
    }
  })

  watch(
    () => props.isOpen,
    (isOpen) => {
      if (!isOpen) {
        resetForm()
      }
    },
  )

  const resetForm = () => {
    members.value = []
    teamId.value = undefined
    showError.value = false
  }

  const cancel = () => {
    resetForm()
    emits('close')
  }

  const submit = () => {
    if (members.value.length === 0) {
      showError.value = true
      return
    }
    emits('membersAdded', {
      members: members.value,
      ...(teamId.value ? { teamId: teamId.value } : {}),
    })
  }
</script>
